import React from 'react';
import PropTypes from 'prop-types';
import DropdownIcon from '../icons/dropdownIcon';

const DropdownInputBorder = ({ label, value, handleClick }) => (
  <div
    className="dropdown-bordered"
    onClick={handleClick}
    role="button"
    aria-hidden
  >
    <p>{label}</p>
    <div className="dropdown-bordered__body">
      <span>{value}</span>
      <DropdownIcon />
    </div>
  </div>
);

DropdownInputBorder.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  handleClick: PropTypes.func,
};

export default DropdownInputBorder;
